import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Text,
  VStack,
} from '@chakra-ui/react';
import { AiOutlineDownCircle, AiOutlineUpCircle } from 'react-icons/ai';
import {
  RULES_DURING_TOURNAMENT_ANCHOR,
  TOURNAMENT_RULES_FAQ,
  TOURNAMENT_RULES_INTRO,
  TOURNAMENT_RULES_TIMELINE,
} from '@/constants/tournamentRulesCopy';
import { useHomePageColors } from '@/hooks/useHomePageColors';
import { HomeHeading } from '@/components/rulesMarketing/HomeHeading';

export function RulesTournamentSection() {
  const { heading, surfaceMuted, brandAccent, bodyMuted } = useHomePageColors();

  return (
    <VStack
      id={RULES_DURING_TOURNAMENT_ANCHOR}
      scrollMarginTop='5rem'
      pb='24px'
      px={{ base: '1em', md: '24px' }}
      w='full'
      spacing={4}
    >
      <HomeHeading mb='0.5em' fontWeight={700}>
        During the Tournament
      </HomeHeading>
      <Text
        textAlign='center'
        color={bodyMuted}
        fontSize={{ base: '13px', md: '15px' }}
        maxW='42rem'
        mx='auto'
        lineHeight='tall'
        whiteSpace='pre-line'
      >
        {TOURNAMENT_RULES_INTRO}
      </Text>
      <Text
        textAlign='center'
        color={heading}
        fontSize={{ base: '12px', md: '13px' }}
        fontWeight={600}
        maxW='40rem'
        mx='auto'
      >
        {TOURNAMENT_RULES_TIMELINE}
      </Text>
      <Accordion maxW='full' w='full' allowToggle>
        <Flex flexDir='column' w='100%' gap='14px'>
          {TOURNAMENT_RULES_FAQ.map(({ question, answer }) => (
            <AccordionItem key={question} border='none'>
              {({ isExpanded }) => (
                <>
                  <AccordionButton
                    border='none'
                    py='1.0em'
                    bgColor={surfaceMuted}
                    borderTopRadius='8px'
                    borderBottomRadius={isExpanded ? 0 : '8px'}
                    overflowX='hidden'
                    _hover={{ bg: surfaceMuted }}
                  >
                    <Box as='span' flex='1' textAlign='left'>
                      <Text
                        as='b'
                        fontWeight={600}
                        fontSize={{ base: '13px', md: '15px' }}
                      >
                        {question}
                      </Text>
                    </Box>
                    {isExpanded ? (
                      <AiOutlineUpCircle size='24px' fill={brandAccent} />
                    ) : (
                      <AiOutlineDownCircle size='24px' fill={brandAccent} />
                    )}
                  </AccordionButton>
                  <AccordionPanel
                    pb={4}
                    bgColor={surfaceMuted}
                    borderBottomRadius='8px'
                    color={bodyMuted}
                    textAlign='left'
                    fontSize={{ base: '13px', md: '14px' }}
                    lineHeight='tall'
                  >
                    {answer}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          ))}
        </Flex>
      </Accordion>
    </VStack>
  );
}
